import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  InputGroup,
  InputGroupSeparator,
  ToggleButton,
} from 'mailup-web-components'

import type { ModalBulkFindReplaceState } from 'Pages/RecipientsList/model'

import IconCheckDoubleSolid from 'Components/icons/IconCheckDoubleSolid'
import IconIndentSolid from 'Components/icons/IconIndentSolid'
import IconSquareQuoteRegular from 'Components/icons/IconSquareQuoteRegular'

import { modalBulkFindReplaceChangeFieldCallback } from 'Pages/RecipientsList/recoil/callbacks/modalBulkFindReplace'
import {
  modalBulkFindReplaceEqualsDisabledState,
  modalBulkFindReplaceState,
} from 'Pages/RecipientsList/recoil/state/modalBulkFindReplace'

const InputMode: FC = () => {
  const intl = useIntl()

  const { FindType, previewStatus } = useRecoilValue(modalBulkFindReplaceState)

  const equalsIsDisabled = useRecoilValue(
    modalBulkFindReplaceEqualsDisabledState,
  )

  const changeField = useRecoilCallback(
    modalBulkFindReplaceChangeFieldCallback,
    [],
  )

  const handleChangeFindType =
    (m: ModalBulkFindReplaceState['FindType']) => (): void => {
      void changeField('FindType', m)
    }

  const disabled = previewStatus === 'fetching'

  return (
    <InputGroup>
      <ToggleButton
        selected={FindType === 'Contains'}
        onClick={handleChangeFindType('Contains')}
        data-mu-test="find-type-contains"
        data-tip={intl.formatMessage({
          id: 'Load.RecipientsList.ModeContainsTooltip',
        })}
        disabled={disabled}
      >
        <IconCheckDoubleSolid height="15px" />
      </ToggleButton>

      <InputGroupSeparator />

      <ToggleButton
        selected={FindType === 'Equals'}
        onClick={handleChangeFindType('Equals')}
        data-mu-test="find-type-equals"
        data-tip={intl.formatMessage({
          id: 'Load.RecipientsList.ModeEqualsTooltip',
        })}
        disabled={disabled || equalsIsDisabled}
      >
        <IconSquareQuoteRegular height="15px" />
      </ToggleButton>

      <InputGroupSeparator />

      <ToggleButton
        selected={FindType === 'StartsWith'}
        onClick={handleChangeFindType('StartsWith')}
        data-mu-test="find-type-starts-with"
        data-tip={intl.formatMessage({
          id: 'Load.RecipientsList.ModeStartsWithTooltip',
        })}
        disabled={disabled}
      >
        <IconIndentSolid height="15px" />
      </ToggleButton>

      <InputGroupSeparator />

      <ToggleButton
        selected={FindType === 'EndsWith'}
        onClick={handleChangeFindType('EndsWith')}
        data-mu-test="find-type-ends-with"
        data-tip={intl.formatMessage({
          id: 'Load.RecipientsList.ModeEndsWithTooltip',
        })}
        disabled={disabled}
      >
        <IconIndentSolid flipH height="15px" />
      </ToggleButton>
    </InputGroup>
  )
}

export default InputMode
